import { NimbleEmojiIndex } from "emoji-mart";

import data from "emoji-mart/data/all.json";

export const emojiIndex = new NimbleEmojiIndex(data);
